/* ==========================================================================
  main.js
========================================================================== */

"use strict";

/* global Accordion, Toastify */

/**
 * Remove / Add CSS classes if header is scrolled
 */

let scrollpos = window.scrollY;
const header = document.querySelector(".site-header");
const scrollChange = 1;
const initiallyBlured = header.classList.contains("site-header--blured");

window.addEventListener("scroll", function () {
  scrollpos = window.scrollY;

  if (scrollpos >= scrollChange) {
    header.classList.add("site-header--scrolled");

    if (initiallyBlured) {
      header.classList.remove("site-header--blured");
    }
  } else {
    header.classList.remove("site-header--scrolled");

    if (initiallyBlured) {
      header.classList.add("site-header--blured");
    }
  }
});

/**
 * Accordion for you are block, only for mobile
 * page template : page-templates/page-vous-etes.php
 */
const youAreContainer = document.querySelector(".you-are-blocks");

if( youAreContainer !== null ) {

  const allBlocks = youAreContainer.querySelectorAll(".you-are-block");

  const accordionYouAre = new Accordion('.you-are-blocks', {
    duration: 400,
    elementClass: "you-are-block",
    triggerClass: "you-are-block__header",
    panelClass: "you-are-block__panel",
    beforeOpen: (currElement) => {
      allBlocks.forEach((element) => {
        element.classList.remove("you-are-block--closed");

        if (element !== currElement) {
          element.classList.add("you-are-block--closed");
        }
      });
    }
  });

  const handleResize = () => {
    const windowWidth = window.innerWidth;

    if (windowWidth <= 890) {
      accordionYouAre.attachEvents();
      accordionYouAre.closeAll();
    } else {
      accordionYouAre.detachEvents();
      accordionYouAre.openAll();
    }
  };

  window.addEventListener('load', handleResize);
  window.addEventListener('resize', handleResize);

}

/**
 * Accordion home page "Agir avec nous"
 */
/**
 * Accordion for you are block, only for mobile
 * page template : page-templates/page-vous-etes.php
 */
const agirContainer = document.querySelector(".home-agir__grid");

if( agirContainer !== null ) {

  const accordionYouAre = new Accordion('.home-agir__grid', {
    duration: 400,
    elementClass: "home-agir__panel",
    triggerClass: "home-agir__panel__header",
    panelClass: "home-agir__panel__content",
  });

  const handleResize = () => {
    const windowWidth = window.innerWidth;

    if (windowWidth <= 890) {
      accordionYouAre.attachEvents();
      accordionYouAre.closeAll();
    } else {
      accordionYouAre.detachEvents();
      accordionYouAre.openAll();
    }
  };

  window.addEventListener('load', handleResize);
  window.addEventListener('resize', handleResize);

}
